import gql from "graphql-tag";

export const updatePrimarySummoner = `updatePrimarySummoner(regionId: $regionId, summonerName: $summonerName) {
    success
  }`;

const UPDATE_PRIMARY_SUMMONER = gql`
  query UpdatePrimarySummoner($regionId: String!, $summonerName: String!) {
    updatePrimarySummoner(regionId: $regionId, summonerName: $summonerName) {
      success
    }
  }
`;

export default UPDATE_PRIMARY_SUMMONER;
